<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{flow_steps, user_data} from './stores.js';
    import { onMount } from "svelte";
    import Servicestemplate from "./components/servicestemplate.svelte";

    onMount(async() => {

    });

</script>

<Servicestemplate>
    <div class="partcontainer toppartcontainer" slot="top_service">
        <div class="leftpartcontainer">
            <div class="tlslugcontainer">Coming soon: HomeEasy title</div>
            <div class="tltitlecontainer">We’re streamlining your closing</div>
            <div class="tlcopycontainer">Now you can close on your schedule, all in one place, when you use HomeEasy title insurance.</div>
            <div class="tlbuttoncontainer">
                <button
            class="darken"
            on:click={() => {
              window.location.href =
                "https://asksemper.zendesk.com/hc/en-us/";
            }}>Contact us</button
          >
            </div>
        </div>
        <div class="rightpartcontainer">
            <div class="trimagecontainer">
                <img src="/img/title_insurance_top_right.png" alt="Title insurance">
            </div>
        </div>
    </div>
    <div class="partcontainer bottompartcontainer" slot="bottom_service">
        <div class="leftpartcontainer">
            <div class="bltitlecontainer">Our process puts you in control</div>
        </div>
        <div class="rightpartcontainer">
            <div class="brinfolistcontainer">

                <div class="brinfolistcontaineritem">
                    <div class="brilcititle">Transparent Rates</div>
                    <div class="brilcicopy">We're honest about your rates and have zero hidden fees.</div>
                </div>

                <div class="brinfolistcontaineritem">
                    <div class="brilcititle">Close on Time</div>
                    <div class="brilcicopy">We make it easy for you to close on time by working closely  with all parties.</div>
                </div>

                <div class="brinfolistcontaineritem">
                    <div class="brilcititle">Work around your schedule</div>
                    <div class="brilcicopy">Our team will meet you whenever and wherever is best for your needs.</div>
                </div>

            </div>
        </div>
    </div>
</Servicestemplate>

<style>
    .partcontainer {
        display: flex;
        width: 100%;
    }
    .toppartcontainer {
        background-color: white;
        padding-top: 90px;
        padding-bottom: 90px;
    }
    .bottompartcontainer {
        color: white;
        background-color: var(--eclipse);
        padding-top: 100px;
        padding-bottom: 100px;
        width: 90%;
        max-width: 1400px;
        min-width: 1240px;
        margin-left: auto;
        margin-right: auto;

    }
    .leftpartcontainer, .rightpartcontainer {
        flex: 1;
    }
    .toppartcontainer > .leftpartcontainer {
        display: flex;
        flex-direction: column;
        text-align: left;
    }
    .tlslugcontainer, .tltitlecontainer, .tlcopycontainer {
        max-width: 510px;
        padding-bottom: 30px;
    }

    .tlslugcontainer {
        color: #343d50;
        font-size: 1.2em;
        font-weight: 600;
        padding-top: 80px;
    }
    .tltitlecontainer {
        color: black;
        font-size: 3em;
        font-weight: 600;
        word-spacing: -1px;
    }
    .tlcopycontainer {
        color: #657680;
        font-size: 1em;
        font-weight: normal;
        line-height: 1.5em;
    }
    .tlbuttoncontainer button {
        display: inline-block;
        /* line-height: 50px; */
        text-align: center;
        vertical-align: middle;
        /* height: 64px; */
        padding-left: 40px;
        padding-right: 40px;
        padding-top: 15px;
        padding-bottom: 15px;
        font-weight: 700;
        font-size: 1em;
        /* color: var(--darkgray); */
        color: white;
        background-color: var(--semperred);
        /* border-style: solid; */
        border-width: 0px;
        /* border-color: white; */
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.25s linear;
        box-sizing: border-box;
    }

    .toppartcontainer > .rightpartcontainer {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .trimagecontainer {
        width: 80%;
        max-width: 510px;
    }
    .trimagecontainer img {
        width: 100%;
    }

    .bltitlecontainer, .brilcititle, .brilcicopy {
        max-width: 510px;
    }
    .bltitlecontainer {
        color: white;
        font-size: 3em;
        font-weight: 600;
    }
    .brilcititle {
        font-size: 1.2em;
        font-weight: 600;
    }
    .brilcicopy {
        font-size: 1em;
        font-weight: normal;
        line-height: 1.5em;
        padding-top: 15px;
    }
    .brinfolistcontaineritem:not(:first-child) {
        margin-top: 50px;
    }
    
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .partcontainer {
            flex-direction: column;
        }
        .toppartcontainer {
            padding-top: 0px;
            padding-bottom: 80px;
            display: flex;
            flex-direction: column;
        }
        .toppartcontainer > .leftpartcontainer {
            display: flex;
            flex-direction: column;
            text-align: center;
            padding-left: 40px;
            padding-right: 40px;
        }
        .tlslugcontainer, .tltitlecontainer, .tlcopycontainer {
            max-width: 100%;
            padding-bottom: 30px;
        }
        .toppartcontainer > .rightpartcontainer {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding-top: 80px;
        }
        .trimagecontainer {
            width: 80%;
            max-width: 80%;
        }
        .bltitlecontainer, .brilcititle, .brilcicopy {
            max-width: 100%;
        }
        .bltitlecontainer {
            padding-bottom: 50px;
        }
        .bottompartcontainer {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
            text-align: center;
            padding-left: 40px;
            padding-right: 40px;
            flex-direction: column;
            box-sizing: border-box;
            padding-top: 100px;
            padding-bottom: 100px;
        }

    }
</style>